import { Link, useParams } from "react-router-dom";
import { ArrowLeft, MoveRight } from "lucide-react";
import { wardrobes } from "@/wardrobes";

export function WardrobeDetail() {
  const { slug } = useParams();
  const wardrobe = wardrobes.find((w) => w.slug === slug);

  if (!wardrobe) {
    return (
      <section className="kitchen-detail" data-testid="wardrobe-not-found">
        <Link to="/wardrobes" className="back-link" data-testid="back-to-collection-link">
          <ArrowLeft size={15} /> Back to the collection
        </Link>
        <h1 className="detail-missing">This wardrobe is not in our collection.</h1>
      </section>
    );
  }

  return (
    <section className="kitchen-detail" data-testid="wardrobe-detail-page">
      <Link to="/wardrobes" className="back-link" data-testid="back-to-collection-link">
        <ArrowLeft size={15} /> Back to the collection
      </Link>
      <div className="detail-grid">
        <figure className="detail-image" data-testid="wardrobe-detail-image">
          <img src={wardrobe.image} alt={wardrobe.alt} />
          <figcaption>{wardrobe.index} / 10 — {wardrobe.finish}</figcaption>
        </figure>
        <div className="detail-specs">
          <span className="eyebrow">Wardrobe {wardrobe.index} / 10</span>
          <h1 data-testid="wardrobe-detail-title">{wardrobe.name}</h1>
          <p className="detail-description" data-testid="wardrobe-detail-description">{wardrobe.description}</p>
          <dl className="spec-list" data-testid="wardrobe-spec-list">
            <div className="spec-row" data-testid="spec-finish">
              <dt>Finish</dt>
              <dd>{wardrobe.finish}</dd>
            </div>
            <div className="spec-row" data-testid="spec-layout">
              <dt>Layout</dt>
              <dd>{wardrobe.layout}</dd>
            </div>
            <div className="spec-row" data-testid="spec-materials">
              <dt>Materials</dt>
              <dd>
                <ul>
                  {wardrobe.materials.map((m) => <li key={m}>{m}</li>)}
                </ul>
              </dd>
            </div>
          </dl>
          <Link to="/contact" className="button" data-testid="wardrobe-consultation-cta">
            Book a private consultation <MoveRight size={17} />
          </Link>
        </div>
      </div>
    </section>
  );
}
